import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { Button } from '@zurich-primitives/button';
import { LoadingSpinner } from 'app/components';
import {
  setUserAccount,
  useAppDispatch,
  handleLoginMsal,
  getAccountInfo
} from 'app';
import ZurichLogoWhite from 'app/assets/ZurichLogoWhite.svg';
import GenAIBrainLogo from 'app/assets/Icons/GenAIBrainLogo.svg';
import styles from './Login.module.scss';
import config from 'config';
import { getAccountInfoMock } from 'app/auth/msal';

export const LoginView: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  const handleResponse = (accountMsal: any): void => {
    dispatch(setUserAccount(accountMsal));
    navigate(config.APP.PATH.LANDING);
  };

  const navLanding = (): void => {
    const accountMsalInfo =
      config.AUTH.ENABLED === 'true' ? getAccountInfo() : getAccountInfoMock();
    if (accountMsalInfo?.idTokenClaims?.oid != null) {
      handleResponse(accountMsalInfo);
    } else {
      navigate(config.APP.PATH.SORRY);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navLanding();
    }
  }, [isAuthenticated]);

  const handleLogin = async (): Promise<any> => {
    const accountMsalInfo = getAccountInfo();
    if (accountMsalInfo === null) {
      handleLoginMsal();
    } else {
      navLanding();
    }
  };

  const handleLoginMock = (): void => {
    navLanding();
  };

  const handleLoginSwitch = (): void => {
    if (config.AUTH.ENABLED === 'true') {
      handleLogin();
    } else {
      handleLoginMock();
    }
  };

  return (
    <div className={styles.login}>
      {!isAuthenticated ? (
        <>
          <div className={styles.image}>
            <img
              className={styles.logo}
              src={ZurichLogoWhite}
              alt="Zurich Logo"
              aria-hidden
            />
          </div>
          <div className={styles.main}>
            <img src={GenAIBrainLogo} alt="GenAI Logo" aria-hidden />
            <div className={styles.text}>
              <div>
                <p className={styles.welcome}>Welcome to</p>
                <p className={styles.genai}>GenAI Services</p>
                <p className={styles.info}>
                  Upload your business inputs
                  <br />
                  and let GenAIQ do the rest
                </p>
              </div>
              <Button onClick={handleLoginSwitch} size="medium">
                <Button.Label>Enter</Button.Label>
              </Button>
            </div>
            <footer>Powered by GenAI Lounge & Services</footer>
          </div>{' '}
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default LoginView;
